import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/en-gb';
import { createI18n, LocaleMessages, VueMessageType } from 'vue-i18n'


/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages(): LocaleMessages<VueMessageType> {
  const locales = require.context('../i18n', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages: LocaleMessages<VueMessageType> = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  })
  return messages
}

const acceptedLocale: string[] = ['en', 'fr'];
let locale: string = 'en';
if(navigator && navigator.languages != undefined) {
  locale = navigator.languages.find(lang => acceptedLocale.includes(lang)) || 'en';
}


const momentLocales = {
  'en': 'en-gb',
  'fr': 'fr',
  'ja': 'ja',
}
moment.locale(momentLocales[locale] || 'en-gb');

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: locale || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
});

export default i18n;
const { t } = i18n.global;
export { t as $t };





